import axios from '../axios'
// 部门查询列表分页信息
export const getBaseDeptPage = data => {
  return axios({
    url: '/api/sys/base/dept/getBaseDeptPage',
    method: 'post',
    data
  })
}
// 部门查询列表分页信息
export const selectByAnyDeptTree = data => {
  return axios({
    url: '/api/sys/base/dept/selectByAnyDeptTree',
    method: 'post',
    data
  })
}
// 部门查询单条记录信息
export const getBaseDept = data => {
  return axios({
    url: '/api/sys/base/dept/getBaseDept',
    method: 'post',
    data
  })
}
export const save = (data) => {
  // 增
  if (!data.id) {
    return axios({
      url: '/api/sys/base/dept/saveBaseDept',
      method: 'post',
      data
    })
  } else { // 改
    return axios({
      url: '/api/sys/base/dept/updateBaseDept',
      method: 'post',
      data
    })
  }
}
// 删除
export const del = (data) => {
  return axios({
    url: '/api/sys/base/dept/deleteBaseDepts',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/moudules/department.js